"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 *  @preserve
 *
 *  @module      iframe-resizer/parent 5.3.1 (iife)
 *
 *  @license     GPL-3.0 for non-commercial use only.
 *               For commercial use, you must purchase a license from
 *               https://iframe-resizer.com/pricing
 *
 *  @description Keep same and cross domain iFrames sized to their content
 *
 *  @author      David J. Bradshaw <info@iframe-resizer.com>
 *
 *  @see         {@link https://iframe-resizer.com}
 *
 *  @copyright  (c) 2013 - 2024, David J. Bradshaw. All rights reserved.
 */

!function () {
  "use strict";

  var e = "[iframe-resizer]";
  var t = function t(_t) {
      return "".concat(e, "[").concat(function (e, _window) {
        return window.top === window.self ? "Parent page: ".concat(e) : (_window = window) !== null && _window !== void 0 && (_window = _window.parentIFrame) !== null && _window !== void 0 && _window.getId ? "".concat(window.parentIFrame.getId(), ": ").concat(e) : "Nested parent page: ".concat(e);
      }(_t), "]");
    },
    i = function i(e) {
      for (var _len = arguments.length, i = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        i[_key - 1] = arguments[_key];
      }
      return function (e, i) {
        var _window2, _window2$console;
        for (var _len2 = arguments.length, n = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          n[_key2 - 2] = arguments[_key2];
        }
        return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$console = _window2.console)[e].apply(_window2$console, [t(i)].concat(n));
      }.apply(void 0, ["warn", e].concat(i));
    },
    n = function n(t, i) {
      var _console;
      return (_console = console) === null || _console === void 0 ? void 0 : _console.warn(function (e) {
        return function (t) {
          return window.chrome ? e(t.replaceAll("<br>", "\n").replaceAll("<rb>", "[31;1m").replaceAll("</>", "[m").replaceAll("<b>", "[1m").replaceAll("<i>", "[3m").replaceAll("<u>", "[4m")) : e(t.replaceAll("<br>", "\n").replaceAll(/<[/a-z]+>/gi, ""));
        };
      }(function (t) {
        return function () {
          for (var _len3 = arguments.length, i = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            i[_key3] = arguments[_key3];
          }
          return ["".concat(e, "[").concat(t, "]")].concat(i).join(" ");
        };
      }(t))(i));
    },
    o = "5.3.1",
    r = "[iFrameSizer]",
    a = r.length,
    s = Object.freeze({
      max: 1,
      scroll: 1,
      bodyScroll: 1,
      documentElementScroll: 1
    }),
    l = function l(e, t, i, n) {
      return e.addEventListener(t, i, n || !1);
    },
    c = function c(e, t, i) {
      return e.removeEventListener(t, i, !1);
    },
    d = function d(e) {
      if (!e) return "";
      var t = -559038744,
        i = 1103547984;
      for (var _n, _o = 0; _o < e.length; _o++) _n = e.codePointAt(_o), t = Math.imul(t ^ _n, 2246822519), i = Math.imul(i ^ _n, 3266489917);
      return t ^= Math.imul(t ^ i >>> 15, 1935289751), i ^= Math.imul(i ^ t >>> 15, 3405138345), t ^= i >>> 16, i ^= t >>> 16, (2097152 * (i >>> 0) + (t >>> 11)).toString(36);
    },
    u = function u(e) {
      return e.replaceAll(/[A-Za-z]/g, function (e) {
        return String.fromCodePoint((e <= "Z" ? 90 : 122) >= (e = e.codePointAt(0) + 19) ? e : e - 26);
      });
    },
    f = ["<iy><yi>Puchspk Spjluzl Rlf</><iy><iy>", "<iy><yi>Tpzzpun Spjluzl Rlf</><iy><iy>", "Aopz spiyhyf pz hchpshisl dpao ivao Jvttlyjphs huk Vwlu-Zvbyjl spjluzlz.<iy><iy><i>Jvttlyjphs Spjluzl</><iy>Mvy jvttlyjphs bzl, <p>pmyhtl-ylzpgly</> ylxbpylz h svd jvza vul aptl spjluzl mll. Mvy tvyl pumvythapvu cpzpa <b>oaawz://pmyhtl-ylzpgly.jvt/wypjpun</>.<iy><iy><i>Vwlu Zvbyjl Spjluzl</><iy>Pm fvb hyl bzpun aopz spiyhyf pu h uvu-jvttlyjphs vwlu zvbyjl wyvqlja aolu fvb jhu bzl pa mvy myll bukly aol alytz vm aol NWS C3 Spjluzl. Av jvumpyt fvb hjjlwa aolzl alytz, wslhzl zla aol <i>spjluzl</> rlf pu <p>pmyhtl-ylzpgly</> vwapvuz av <i>NWSc3</>.<iy><iy>Mvy tvyl pumvythapvu wslhzl zll: <b>oaawz://pmyhtl-ylzpgly.jvt/nws</>", "<i>NWSc3 Spjluzl Clyzpvu</><iy><iy>Aopz clyzpvu vm <p>pmyhtl-ylzpgly</> pz ilpun bzlk bukly aol alytz vm aol <i>NWS C3</> spjluzl. Aopz spjluzl hssvdz fvb av bzl <p>pmyhtl-ylzpgly</> pu Vwlu Zvbyjl wyvqljaz, iba pa ylxbpylz fvby wyvqlja av il wbispj, wyvcpkl haaypibapvu huk il spjluzlk bukly clyzpvu 3 vy shaly vm aol NUB Nlulyhs Wbispj Spjluzl.<iy><iy>Pm fvb hyl bzpun aopz spiyhyf pu h uvu-vwlu zvbyjl wyvqlja vy dlizpal, fvb dpss ullk av wbyjohzl h svd jvza vul aptl jvttlyjphs spjluzl.<iy><iy>Mvy tvyl pumvythapvu cpzpa <b>oaawz://pmyhtl-ylzpgly.jvt/wypjpun</>."],
    p = ["NWSc3", "zvsv", "wyv", "ibzpulzz", "vlt"],
    h = Object.fromEntries(["2cgs7fdf4xb", "1c9ctcccr4z", "1q2pc4eebgb", "ueokt0969w", "w2zxchhgqz", "1umuxblj2e5"].map(function (e, t) {
      return [e, Math.max(0, t - 1)];
    })),
    m = function m(e) {
      return u(f[e]);
    };
  var y = function y(e) {
    var t = e[u("spjluzl")];
    if (!t) return -1;
    var i = t.split("-");
    var n = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var t = -2;
      var i = d(u(e));
      return i in h && (t = h[i]), t;
    }(i[0]);
    return 0 === n || function (e) {
      return e[2] === d(e[0] + e[1]);
    }(i) || (n = -2), n;
  };
  var g = {};
  var w = Object.freeze({
      autoResize: !0,
      bodyBackground: null,
      bodyMargin: null,
      bodyPadding: null,
      checkOrigin: !0,
      direction: "vertical",
      inPageLinks: !1,
      heightCalculationMethod: "auto",
      id: "iFrameResizer",
      log: !1,
      license: void 0,
      mouseEvents: !0,
      offsetHeight: null,
      offsetWidth: null,
      postMessageTarget: null,
      sameDomain: !1,
      scrolling: !1,
      sizeHeight: !0,
      sizeWidth: !1,
      warningTimeout: 5e3,
      tolerance: 0,
      waitForLoad: !1,
      widthCalculationMethod: "auto",
      onClose: function onClose() {
        return !0;
      },
      onClosed: function onClosed() {},
      onInit: !1,
      onMessage: null,
      onMouseEnter: function onMouseEnter() {},
      onMouseLeave: function onMouseLeave() {},
      onReady: function onReady(e) {
        "function" == typeof g[e.id].onInit && (n(e.id, "\n[31;1mDeprecated Option[m\n\nThe [1monInit()[m function is deprecated and has been replaced with [1monReady()[m. It will be removed in a future version of iFrame Resizer.\n      "), g[e.id].onInit(e));
      },
      onResized: function onResized() {},
      onScroll: function onScroll() {
        return !0;
      }
    }),
    b = {
      position: null,
      version: o
    };
  function v(e) {
    function t() {
      I(H), R(), A("onResized", H);
    }
    function s(e) {
      if ("border-box" !== e.boxSizing) return 0;
      return (e.paddingTop ? parseInt(e.paddingTop, 10) : 0) + (e.paddingBottom ? parseInt(e.paddingBottom, 10) : 0);
    }
    function d(e) {
      if ("border-box" !== e.boxSizing) return 0;
      return (e.borderTopWidth ? parseInt(e.borderTopWidth, 10) : 0) + (e.borderBottomWidth ? parseInt(e.borderBottomWidth, 10) : 0);
    }
    var u = function u(e) {
      return C.slice(C.indexOf(":") + 7 + e);
    };
    var f = function f(e, t) {
        return function (i, n) {
          var o = {};
          var r, a;
          r = function r() {
            S("Send ".concat(e, " (").concat(i, ")"), "".concat(e, ":").concat(t()), n);
          }, o[a = n] || (r(), o[a] = requestAnimationFrame(function () {
            o[a] = null;
          }));
        };
      },
      p = function p(e, t) {
        return function () {
          var i = !1;
          var n = function n(t) {
              return function () {
                g[d] ? i && i !== t || (e(t, d), i = t, requestAnimationFrame(function () {
                  i = !1;
                })) : s();
              };
            },
            o = n("scroll"),
            r = n("resize window");
          function a(e, t) {
            t(window, "scroll", o), t(window, "resize", r);
          }
          function s() {
            a(0, c), u.disconnect(), f.disconnect();
          }
          var d = P,
            u = new ResizeObserver(n("page observed")),
            f = new ResizeObserver(n("iframe observed"));
          a(0, l), u.observe(document.body, {
            attributes: !0,
            childList: !0,
            subtree: !0
          }), f.observe(g[d].iframe, {
            attributes: !0,
            childList: !1,
            subtree: !1
          }), g[d] && (g[d]["stop".concat(t)] = s);
        };
      },
      h = function h(e) {
        return function () {
          e in g[P] && (g[P][e](), delete g[P][e]);
        };
      },
      m = f("pageInfo", function () {
        var e = document.body.getBoundingClientRect(),
          t = H.iframe.getBoundingClientRect(),
          _window3 = window,
          i = _window3.scrollY,
          n = _window3.scrollX,
          o = _window3.innerHeight,
          r = _window3.innerWidth,
          _document$documentEle = document.documentElement,
          a = _document$documentEle.clientHeight,
          s = _document$documentEle.clientWidth;
        return JSON.stringify({
          iframeHeight: t.height,
          iframeWidth: t.width,
          clientHeight: Math.max(a, o || 0),
          clientWidth: Math.max(s, r || 0),
          offsetTop: parseInt(t.top - e.top, 10),
          offsetLeft: parseInt(t.left - e.left, 10),
          scrollTop: i,
          scrollLeft: n,
          documentHeight: a,
          documentWidth: s,
          windowHeight: o,
          windowWidth: r
        });
      }),
      y = f("parentInfo", function () {
        var _H = H,
          e = _H.iframe,
          _document$documentEle2 = document.documentElement,
          t = _document$documentEle2.scrollWidth,
          i = _document$documentEle2.scrollHeight,
          _window$visualViewpor = window.visualViewport,
          n = _window$visualViewpor.width,
          o = _window$visualViewpor.height,
          r = _window$visualViewpor.offsetLeft,
          a = _window$visualViewpor.offsetTop,
          s = _window$visualViewpor.pageLeft,
          l = _window$visualViewpor.pageTop,
          c = _window$visualViewpor.scale;
        return JSON.stringify({
          iframe: e.getBoundingClientRect(),
          document: {
            scrollWidth: t,
            scrollHeight: i
          },
          viewport: {
            width: n,
            height: o,
            offsetLeft: r,
            offsetTop: a,
            pageLeft: s,
            pageTop: l,
            scale: c
          }
        });
      }),
      w = p(m, "PageInfo"),
      v = p(y, "ParentInfo"),
      j = h("stopPageInfo"),
      E = h("stopParentInfo");
    function F(e) {
      var t = e.getBoundingClientRect();
      return $(), {
        x: Number(t.left) + Number(b.position.x),
        y: Number(t.top) + Number(b.position.y)
      };
    }
    function N(e) {
      var t = e ? F(H.iframe) : {
          x: 0,
          y: 0
        },
        i = function (e, t) {
          return {
            x: e.width + t.x,
            y: e.height + t.y
          };
        }(H, t),
        n = window.parentIframe || window.parentIFrame;
      n ? function (t, i) {
        t["scrollTo" + (e ? "Offset" : "")](i.x, i.y);
      }(n, i) : function (e) {
        b.position = e, L(P);
      }(i);
    }
    function L(e) {
      var _g$e;
      var _b$position = b.position,
        t = _b$position.x,
        i = _b$position.y,
        n = (_g$e = g[e]) === null || _g$e === void 0 ? void 0 : _g$e.iframe;
      !1 !== A("onScroll", {
        iframe: n,
        top: i,
        left: t,
        x: t,
        y: i
      }) ? R() : k();
    }
    function O(e) {
      var t = {};
      if (0 === H.width && 0 === H.height) {
        var _e = u(9).split(":");
        t = {
          x: _e[1],
          y: _e[0]
        };
      } else t = {
        x: H.width,
        y: H.height
      };
      A(e, {
        iframe: H.iframe,
        screenX: Number(t.x),
        screenY: Number(t.y),
        type: H.type
      });
    }
    var A = function A(e, t) {
      return z(P, e, t);
    };
    var C = e.data,
      H = {},
      P = null;
    "[iFrameResizerChild]Ready" !== C ? r === "".concat(C).slice(0, a) && C.slice(a).split(":")[0] in g && (H = function (_g$e$) {
      var e = C.slice(a).split(":"),
        t = e[1] ? Number(e[1]) : 0,
        i = (_g$e$ = g[e[0]]) === null || _g$e$ === void 0 ? void 0 : _g$e$.iframe,
        n = getComputedStyle(i);
      return {
        iframe: i,
        id: e[0],
        height: t + s(n) + d(n),
        width: Number(e[2]),
        type: e[3],
        msg: e[4]
      };
    }(), P = H.id, P ? (function (e) {
      if (!g[e]) throw new Error("".concat(H.type, " No settings for ").concat(e, ". Message was: ").concat(C));
    }(P), H.type in {
      "true": 1,
      "false": 1,
      undefined: 1
    } || (g[P].loaded = !0, (null !== H.iframe || (i(P, "The iframe (".concat(H.id, ") was not found.")), 0)) && function (_g$P) {
      var t = e.origin,
        i = e.sameDomain;
      if (i) return !0;
      var n = (_g$P = g[P]) === null || _g$P === void 0 ? void 0 : _g$P.checkOrigin;
      if (n && "null" != "".concat(t) && !(n.constructor === Array ? function () {
        var e = 0,
          i = !1;
        for (; e < n.length; e++) if (n[e] === t) {
          i = !0;
          break;
        }
        return i;
      }() : function (_g$P2) {
        var e = (_g$P2 = g[P]) === null || _g$P2 === void 0 ? void 0 : _g$P2.remoteHost;
        return t === e;
      }())) throw new Error("Unexpected message received from: ".concat(t, " for ").concat(H.iframe.id, ". Message was: ").concat(e.data, ". This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains."));
      return !0;
    }() && function (_g$P3) {
      switch ((_g$P3 = g[P]) !== null && _g$P3 !== void 0 && _g$P3.firstRun && g[P] && (g[P].firstRun = !1), H.type) {
        case "close":
          T(H.iframe);
          break;
        case "message":
          r = u(6), A("onMessage", {
            iframe: H.iframe,
            message: JSON.parse(r)
          });
          break;
        case "mouseenter":
          O("onMouseEnter");
          break;
        case "mouseleave":
          O("onMouseLeave");
          break;
        case "autoResize":
          g[P].autoResize = JSON.parse(u(9));
          break;
        case "scrollBy":
          !function () {
            var e = H.width,
              t = H.height;
            (window.parentIframe || window).scrollBy(e, t);
          }();
          break;
        case "scrollTo":
          N(!1);
          break;
        case "scrollToOffset":
          N(!0);
          break;
        case "pageInfo":
          m("start", P), w();
          break;
        case "parentInfo":
          y("start", P), v();
          break;
        case "pageInfoStop":
          j();
          break;
        case "parentInfoStop":
          E();
          break;
        case "inPageLink":
          !function (e) {
            var t = e.split("#")[1] || "",
              i = decodeURIComponent(t);
            var n = document.getElementById(i) || document.getElementsByName(i)[0];
            n ? function () {
              var e = F(n);
              b.position = {
                x: e.x,
                y: e.y
              }, L(P), window.location.hash = t;
            }() : window.top !== window.self && window.parentIFrame && window.parentIFrame.moveToAnchor(t);
          }(u(9));
          break;
        case "title":
          !function (e, t, _g$t) {
            ((_g$t = g[t]) === null || _g$t === void 0 ? void 0 : _g$t.syncTitle) && (g[t].iframe.title = e);
          }(H.msg, P);
          break;
        case "reset":
          M(H);
          break;
        case "init":
          t(), function (e) {
            try {
              var _g$e2;
              g[e].sameDomain = !!((_g$e2 = g[e]) !== null && _g$e2 !== void 0 && (_g$e2 = _g$e2.iframe) !== null && _g$e2 !== void 0 && (_g$e2 = _g$e2.contentWindow) !== null && _g$e2 !== void 0 && _g$e2.iframeChildListener);
            } catch (t) {
              g[e].sameDomain = !1;
            }
          }(P), (e = H.msg) !== o && (void 0 !== e || n(P, "<rb>Legacy version detected in iframe</>\n\nDetected legacy version of child page script. It is recommended to update the page in the iframe to use <b>@iframe-resizer/child</>.\n\nSee <u>https://iframe-resizer.com/setup/#child-page-setup</> for more details.\n")), W = !0, A("onReady", H.iframe);
          break;
        default:
          if (0 === H.width && 0 === H.height) return void i(P, "Unsupported message received (".concat(H.type, "), this is likely due to the iframe containing a later version of iframe-resizer than the parent page"));
          if (0 === H.width || 0 === H.height) return;
          if (document.hidden) return;
          t();
      }
      var e, r;
    }())) : i("", "iframeResizer received messageData without id, message was: ", C)) : Object.keys(g).forEach(function (e) {
      g[e].mode >= 0 && S("iFrame requested init", x(e), e);
    });
  }
  function z(e, t, i) {
    var n = null,
      o = null;
    if (g[e]) {
      if (n = g[e][t], "function" != typeof n) throw new TypeError("".concat(t, " on iFrame[").concat(e, "] is not a function"));
      "onClose" === t || "onScroll" === t ? o = n(i) : setTimeout(function () {
        return n(i);
      });
    }
    return o;
  }
  function j(e) {
    var t = e.id;
    delete g[t];
  }
  function T(e) {
    var t = e.id;
    if (!1 !== z(t, "onClose", t)) {
      try {
        e.parentNode && e.remove();
      } catch (e) {
        i(t, e);
      }
      z(t, "onClosed", t), j(e);
    }
  }
  function $(e) {
    null === b.position && (b.position = {
      x: window.scrollX,
      y: window.scrollY
    });
  }
  function k() {
    b.position = null;
  }
  function R(e) {
    null !== b.position && (window.scrollTo(b.position.x, b.position.y), k());
  }
  function M(e) {
    $(e.id), I(e), S("reset", "reset", e.id);
  }
  function I(e) {
    function t(t) {
      var i = "".concat(e[t], "px");
      e.iframe.style[t] = i;
    }
    var i = e.id,
      _g$i = g[i],
      n = _g$i.sizeHeight,
      o = _g$i.sizeWidth;
    n && t("height"), o && t("width");
  }
  function S(e, t, o, a) {
    var _g$o, _g$o3;
    g[o] && ((_g$o = g[o]) !== null && _g$o !== void 0 && _g$o.postMessageTarget ? function () {
      var _g$o2 = g[o],
        e = _g$o2.iframe,
        i = _g$o2.postMessageTarget,
        n = _g$o2.sameDomain,
        a = _g$o2.targetOrigin;
      if (n) try {
        return void e.contentWindow.iframeChildListener(r + t);
      } catch (e) {}
      i.postMessage(r + t, a);
    }() : i(o, "[".concat(e, "] IFrame(").concat(o, ") not found")), a && ((_g$o3 = g[o]) === null || _g$o3 === void 0 ? void 0 : _g$o3.warningTimeout) && (g[o].msgTimeout = setTimeout(function () {
      if (void 0 === g[o]) return;
      var _g$o4 = g[o],
        e = _g$o4.iframe,
        t = _g$o4.loaded,
        i = _g$o4.loadErrorShown,
        r = _g$o4.waitForLoad,
        a = e.sandbox;
      t || i || (g[o].loadErrorShown = !0, n(o, "\n<rb>No response from iFrame</>\n            \nThe iframe (<i>".concat(o, "</>) has not responded within ").concat(g[o].warningTimeout / 1e3, " seconds. Check <b>@iframe-resizer/child</> package has been loaded in the iframe.\n").concat(r ? "\nThe <b>waitForLoad</> option is currently set to <i>'true'</>. If the iframe loads before the JavaScript runs, this option will prevent <i>iframe-resizer</> from initialising. To disable this, set the <b>waitForLoad</> option to <i>'false'</>.  \n" : "", "\n").concat(!((a === null || a === void 0 ? void 0 : a.length) > 0) || a.contains("allow-scripts") && a.contains("allow-same-origin") ? "" : "The iframe has the <b>sandbox</> attribute, please ensure it contains both the <i>'allow-same-origin'</> and <i>'allow-scripts'</> values.", "\n\nThis message can be ignored if everything is working, or you can set the <b>warningTimeout</> option to a higher value or zero to suppress this warning.\n")));
    }, g[o].warningTimeout)));
  }
  function x(e) {
    var t = g[e];
    return [e, "8", t.sizeWidth, t.log, "32", !0, t.autoResize, t.bodyMargin, t.heightCalculationMethod, t.bodyBackground, t.bodyPadding, t.tolerance, t.inPageLinks, "child", t.widthCalculationMethod, t.mouseEvents, t.offsetHeight, t.offsetWidth, t.sizeHeight, t.license, b.version, t.mode].join(":");
  }
  var E = 0,
    W = !1,
    F = !1;
  var N = function N(e) {
    return function (t) {
      function r(e) {
        if (!e) return {};
        if ("object" != _typeof(e)) throw new TypeError("Options is not an object");
        return ("sizeWidth" in e || "sizeHeight" in e || "autoResize" in e) && n(c, '<rb>Deprecated Option</>\n\nThe <b>sizeWidth</>, <b>sizeHeight</> and <b>autoResize</> options have been replaced with new <b>direction</> option which expects values of <i>"vertical"</>, <i>"horizontal"</> or <i>"horizontal"</>.\n'), e;
      }
      function a(e) {
        var _g$e3;
        var t = (_g$e3 = g[e]) === null || _g$e3 === void 0 || (_g$e3 = _g$e3.iframe) === null || _g$e3 === void 0 ? void 0 : _g$e3.title;
        return "" === t || void 0 === t;
      }
      var c = function (i) {
        if (i && "string" != typeof i) throw new TypeError("Invalid id for iFrame. Expected String");
        return "" !== i && i || (i = function () {
          var t = (e === null || e === void 0 ? void 0 : e.id) || w.id + E++;
          return null !== document.getElementById(t) && (t += E++), t;
        }(), t.id = i, (e || {}).log), i;
      }(t.id);
      return c in g && "iFrameResizer" in t ? i(c, "Ignored iFrame, already setup.") : (function (e) {
        var i, o;
        g[c] = _objectSpread(_objectSpread(_objectSpread({
          iframe: t,
          firstRun: !0,
          remoteHost: t === null || t === void 0 ? void 0 : t.src.split("/").slice(0, 3).join("/")
        }, w), r(e)), {}, {
          mode: y(e),
          syncTitle: a(c)
        }), function () {
          var e = g[c].direction;
          if ("horizontal" === e) return g[c].sizeWidth = !0, void (g[c].sizeHeight = !1);
          if ("none" === e) return g[c].sizeWidth = !1, g[c].sizeHeight = !1, void (g[c].autoResize = !1);
          if ("vertical" !== e) throw new TypeError(c, "Direction value of \"".concat(e, "\" is not valid"));
        }(), (i = (e === null || e === void 0 ? void 0 : e.offsetSize) || (e === null || e === void 0 ? void 0 : e.offset)) && ("vertical" === g[c].direction ? g[c].offsetHeight = i : g[c].offsetWidth = i), e !== null && e !== void 0 && e.offset && n(c, "<rb>Deprecated option</>\n\n The <b>offset</> option has been renamed to <b>offsetSize</>. Use of the old name will be removed in a future version of <i>iframe-resizer</>."), null === g[c].postMessageTarget && (g[c].postMessageTarget = t.contentWindow), g[c].targetOrigin = !0 === g[c].checkOrigin ? "" === (o = g[c].remoteHost) || null !== o.match(/^(about:blank|javascript:|file:\/\/)/) ? "*" : o : "*";
      }(e), function () {
        var e = g[c].mode;
        var t;
        e < 0 && n("Parent", "".concat(m(e + 2)).concat(m(2))), F || e < 0 || (F = !0, t = "v".concat(o, " (").concat(function (e) {
          return u(p[e]);
        }(e), ")"), console.info("%c[iframe-resizer] ".concat(t), "font-weight: bold;"), e < 1 && n("Parent", m(3)));
      }(), O(), function (_g$c, _g$c2) {
        switch (t.style.overflow = !1 === ((_g$c = g[c]) === null || _g$c === void 0 ? void 0 : _g$c.scrolling) ? "hidden" : "auto", (_g$c2 = g[c]) === null || _g$c2 === void 0 ? void 0 : _g$c2.scrolling) {
          case "omit":
            break;
          case !0:
            t.scrolling = "yes";
            break;
          case !1:
            t.scrolling = "no";
            break;
          default:
            t.scrolling = g[c] ? g[c].scrolling : "no";
        }
      }(), function () {
        var e = g[c].bodyMargin;
        "number" != typeof e && "0" !== e || (g[c].bodyMargin = "".concat(e, "px"));
      }(), function (e) {
        var i = t.id,
          _g$i2 = g[i],
          n = _g$i2.mode,
          o = _g$i2.waitForLoad;
        -1 !== n && -2 !== n && (l(t, "load", function () {
          S("iFrame.onload", "".concat(e, ":").concat(W), i, !0), function (_g$c3, _g$c4) {
            var e = (_g$c3 = g[c]) === null || _g$c3 === void 0 ? void 0 : _g$c3.firstRun,
              i = (((_g$c4 = g[c]) === null || _g$c4 === void 0 ? void 0 : _g$c4.heightCalculationMethod) in s);
            !e && i && M({
              iframe: t,
              height: 0,
              width: 0,
              type: "init"
            });
          }();
        }), !1 === o && S("init", "".concat(e, ":").concat(W), i, !0));
      }(x(c)), function () {
        if (g[c]) {
          var _e2 = g[c].iframe,
            _t2 = {
              close: T.bind(null, _e2),
              disconnect: j.bind(null, _e2),
              removeListeners: function removeListeners() {
                n(c, "\n<rb>Deprecated Method Name</>\n\nThe [removeListeners()</> method has been renamed to [disconnect()</>.\n"), this.disconnect();
              },
              resize: S.bind(null, "Window resize", "resize", c),
              moveToAnchor: function moveToAnchor(e) {
                S("Move to anchor", "moveToAnchor:".concat(e), c);
              },
              sendMessage: function sendMessage(e) {
                S("Send Message", "message:".concat(e = JSON.stringify(e)), c);
              }
            };
          _e2.iframeResizer = _t2, _e2.iFrameResizer = _t2;
        }
      }()), t === null || t === void 0 ? void 0 : t.iFrameResizer;
    };
  };
  function L() {
    !1 === document.hidden && function (e, t) {
      var i = function i(e) {
        var _g$e4, _g$e5;
        return ((_g$e4 = g[e]) === null || _g$e4 === void 0 ? void 0 : _g$e4.autoResize) && !((_g$e5 = g[e]) !== null && _g$e5 !== void 0 && _g$e5.firstRun);
      };
      Object.keys(g).forEach(function (n) {
        i(n) && S(e, t, n);
      });
    }("Tab Visible", "resize");
  }
  var O = function (e) {
      var t = !1;
      return function () {
        return t ? void 0 : (t = !0, Reflect.apply(e, this, arguments));
      };
    }(function () {
      l(window, "message", v), l(document, "visibilitychange", L), window.iframeParentListener = function (e) {
        return setTimeout(function () {
          return v({
            data: e,
            sameDomain: !0
          });
        });
      };
    }),
    A = "[iframeResizer] ";
  window.iframeResize = function () {
    function e(e) {
      switch (!0) {
        case !e:
          throw new TypeError("".concat(A, "iframe is not defined"));
        case !e.tagName:
          throw new TypeError("".concat(A, "Not a valid DOM element"));
        case "IFRAME" !== e.tagName.toUpperCase():
          throw new TypeError("".concat(A, "Expected <IFRAME> tag, found <").concat(e.tagName, ">"));
        default:
          t(e), i.push(e);
      }
    }
    var t, i;
    return function (n, o) {
      if ("undefined" == typeof window) return [];
      switch (t = N(n), i = [], _typeof(o)) {
        case "undefined":
        case "string":
          document.querySelectorAll(o || "iframe").forEach(e);
          break;
        case "object":
          e(o);
          break;
        default:
          throw new TypeError("".concat(A, "Unexpected data type (").concat(_typeof(o), ")"));
      }
      return Object.freeze(i);
    };
  }(), window.iFrameResize = function () {
    var _window4;
    n("", "Deprecated: iFrameResize(), please use iframeResize()"), (_window4 = window).iframeResize.apply(_window4, arguments);
  };
}();
iframeResize({
  license: 'GPLv3',
  waitForLoad: false
}, '#iFrameResizer0');
jQuery(document).ready(function ($) {
  frameHeight('.embedded-content iframe body');
  function frameHeight(frameContent) {
    // Get references to elements
    var frameContentSelector = document.querySelector(frameContent);
    if (frameContentSelector) {
      var heightFrameContent = frameContentSelector.clientHeight;

      // console.log('Tab heightFrameContent' + heightFrameContent);

      // Check if heightIframeTotal is not undefined or null
      if (heightFrameContent != null && !isNaN(heightFrameContent)) {
        window.parent.postMessage({
          heightIframeContent: heightFrameContent
        }, "*");
      } else {
        console.log('Height is undefined or null');
      }
    } else {
      //  console.log('One or both of the elements not found');
    }
  }
});